import React, { FC, useState } from 'react';
import { Modal, ModalHeader, ModalActions, Button, ButtonPrimary } from '@lambdacurry/component-library';
import { ActionList } from '../../../components-v2/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { BlocklistEntry } from '../../../services/BlocklistService';

export interface BlockedEmailRowProps {
    entry: BlocklistEntry;
    onDelete: (id: number) => Promise<boolean>;
    disabled?: boolean;
}

export const BlockedEmailRow: FC<BlockedEmailRowProps> = ({ entry, onDelete, disabled }) => {
    const [showModal, setShowModal] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        setDeleting(true);
        const result = await onDelete(entry.id);
        setDeleting(false);

        if (result) {
            setShowModal(false);
        }
    };

    return (
        <>
            <tr className="blocked-email-row">
                <td className="blocked-email-row__email">{entry.email}</td>
                <td className="blocked-email-row__date">{moment(entry.created_at).format('MMM D, YYYY')}</td>
                <td className="blocked-email-row__actions">
                    <button
                        className="blocked-email-row__delete-button"
                        onClick={() => setShowModal(true)}
                        disabled={disabled || deleting}
                        title="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </td>
            </tr>

            <Modal isOpen={showModal} onAfterClose={() => setShowModal(false)}>
                <ModalHeader title="Confirm Delete" />
                <p>
                    Are you sure you want to remove <strong>{entry.email}</strong> from the blocklist?
                </p>
                <p className="blocked-email-row__warning">This email address will be able to submit leads again.</p>
                <ModalActions>
                    <ActionList position="end">
                        <Button onClick={() => setShowModal(false)} disabled={deleting}>
                            Cancel
                        </Button>
                        <ButtonPrimary onClick={handleDelete} disabled={deleting}>
                            {deleting ? 'Deleting...' : 'Delete'}
                        </ButtonPrimary>
                    </ActionList>
                </ModalActions>
            </Modal>
        </>
    );
};
